import React, { Children, cloneElement } from 'react';
import classNames from 'classnames';

/**
 * CheckboxGroup represents a group of Checkbox components that are related.
 *
 *  @callback onChange
 *
 *  @param {Boolean} disabled - Should this group of radio buttons be disabled.
 *  @param {string} name - html name of related radio buttons; the name will be
 *    automatically added to any child Checkbox components.
 *
 *  Example usage with Checkbox component
 *  @example
 *  <CheckboxGroup
 *    name='my_checkboxs'
 *    disabled={this.radiosDisabled()}
 *    onChange={this.handleChange()}
 *  >
 *    <Checkbox value='1'>The First Option</Checkbox>
 *    <Checkbox value='2'>The Second Option</Checkbox>
 *    <Checkbox value='3'>The Third Option</Checkbox>
 *  </CheckboxGroup>
 *
 *
 * @returns {CheckboxGroup} CheckboxGroup containing any Checkbox passed to the
 *    component as children.
 */
const CheckboxGroup = ({ name, onChange, disabled, children, className }) => (
  <fieldset
    className={classNames('CheckboxGroup', className)}
    disabled={disabled}
  >
    {Children.map(children, child =>
      cloneElement(child, {
        name,
        onChange,
      }),
    )}
  </fieldset>
);

export default CheckboxGroup;
